import { createFileRoute } from '@tanstack/react-router';

import { PluginsGrid } from 'component/partial/grids/plugins/PluginsGrid';

export const Route = createFileRoute('/n/_auth/sites/$siteId/_details/plugins/discover')({
  component: PluginsDiscoverRoute,
});

function PluginsDiscoverRoute() {
  return <PluginsGrid />;
}
